import { ReducerUtil } from 'doctivity-shared/utils';

import {
  API_SCORECARDS_TABLE,
  API_SCORECARDS_LIST,
  API_SCORECARDS_UPSERT,
} from 'store/actions/scorecardsActions';

export const scorecards = (state = {}, action = null) => {
  const result = ReducerUtil.simpleReduce(
    state,
    action,
    API_SCORECARDS_TABLE,
    API_SCORECARDS_LIST,
    API_SCORECARDS_UPSERT,
  );
  if (result.actionConsumed) {
    return result.state;
  }
  return state;
};
